import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress } from '@mui/material';

import Deed from 'entities/deed/model';
import CancelButtonIcon from 'assets/icons/cancel-button.svg';
import DialogButton from 'retired/DialogButton';
import Img from 'retired/Img';
import { white } from 'utils/color-styles';

import { removeAttendee, removeInvitee } from './actions';

export const RemoveUserButton = ({
  type,
  userId,
  deed,
  roleId,
}: {
  type: string;
  userId: string;
  deed: Deed;
  roleId?: string;
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <DialogButton
      style={{
        display: 'inline-block',
      }}
      buttonProps={{
        style: {
          border: 0,
          padding: 0,
          opacity: 0.4,
          boxShadow: 'none',
          background: white,
        },
      }}
      buttonLabel={
        isLoading ? (
          <CircularProgress size={18} />
        ) : (
          <Img src={CancelButtonIcon} style={{ width: 20 }} alt="Remove" />
        )
      }
      title={`Remove ${type[0].toUpperCase() + type.substr(1)}`}
      text={`Are you sure you want to remove this ${type} from this event?`}
      confirmLabel="Remove"
      cancelLabel="Cancel"
      handleConfirm={() => {
        if (isLoading) {
          return;
        }
        setIsLoading(true);
        if (type === 'invitee') {
          dispatch(removeInvitee(deed.id, userId));
        } else {
          dispatch(removeAttendee(deed.id, userId, roleId && [roleId]));
        }
      }}
    />
  );
};
